import { motion } from "framer-motion";
import { PROCESS } from "../../data";

const ease = [0.22, 1, 0.36, 1];

const Step = ({ step, i }) => {
  const reverse = i % 2 === 1;
  return (
    <div className="grid md:grid-cols-12 gap-8 md:gap-16 items-center" data-testid={`process-step-${i}`}>
      <motion.div
        initial={{ opacity: 0, y: 60 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.9, ease }}
        className={`md:col-span-6 group ${reverse ? "md:order-2 md:col-start-7" : ""}`}
      >
        <div className="relative overflow-hidden aspect-[4/5] border border-line bg-stone">
          <img src={step.img} alt={step.title} loading="lazy" className={`img-zoom w-full h-full object-cover ${step.pos || "object-center"}`} />
        </div>
      </motion.div>

      <motion.div
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.9, delay: 0.1, ease }}
        className={`md:col-span-5 ${reverse ? "md:order-1 md:col-start-1" : "md:col-start-8"}`}
      >
        <span className="font-serif text-6xl md:text-8xl leading-none text-champagne/60 block mb-6">{step.no}</span>
        <h3 className="font-serif font-light text-3xl md:text-5xl leading-tight tracking-tight mb-5">{step.title}</h3>
        <p className="text-ink/60 font-light leading-relaxed max-w-md">{step.body}</p>
      </motion.div>
    </div>
  );
};

export const Process = () => (
  <section className="py-8 md:py-12" data-testid="process-section">
    <div className="mx-auto max-w-[1600px] px-6 md:px-12 space-y-24 md:space-y-40">
      {PROCESS.map((step, i) => (
        <Step key={step.no} step={step} i={i} />
      ))}
    </div>
  </section>
);
